export class AssertionError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'AssertionError';
  }
}

// Always on. A production build that strips assertions ships the bug instead of the crash.
export function assert(condition: boolean, message: string): asserts condition {
  if (condition) return;
  throw new AssertionError(message);
}

// For exhaustive switches: the compiler proves `x` is never, and the runtime throw covers
// callers that bypass the types (JSON off the wire, untyped JS).
export function unreachable(x: never): never {
  throw new AssertionError(`unreachable: ${String(x)}`);
}
